<template>
  <section id="v1-mainContainer">
    <LoginHeader></LoginHeader>
    <div class="site-mid">
      <div class="v1-login-page client-signup-page">
        <div class="v1-login-page-in">
          <div class="v1-loginForm" id="loginForm">
            <div class="overlay-container">
              <div class="overlay">
                <div class="overlay-panel overlay-left">
                  <h1>
                    {{ constants.LOGIN_LEFT_TEXT }}
                    <br />
                    {{ constants.OUR_FAMILY_TEXT }}
                  </h1>
                  <button id="signIn">
                    {{ constants.LOGIN_BUTTON }}
                  </button>
                </div>

                <!-- <div class="overlay-panel overlay-right">
                  <h1>
                    {{ constants.SIGN_UP_AS_CUSTOMER_TEXT }}
                  </h1>
                  <button id="signUp">
                    {{ constants.SIGN_UP_BUTTON }}
                  </button>
                </div> -->
              </div>
            </div>
            <!---------------------------Sign Up Form Start------------------->
            <!-- <div class="form-container sign-up-container">
              <div class="form-box">
                <h2>
                  {{ constants.CUSTOMER_SIGN_UP_TEXT }}
                </h2>
                <form action="#">
                  <div class="input-row-2">
                    <div class="v1-input-field">
                      <input
                        type="text"
                        class="username"
                        id="firstNameInput"
                        value=""
                        placeholder="First Name"
                      />
                    </div>
                    <div class="v1-input-field">
                      <input
                        type="text"
                        class="username"
                        id="lastNameInput"
                        value=""
                        placeholder="Last Name"
                      />
                    </div>
                  </div>
                  <div class="v1-input-field">
                    <input
                      type="text"
                      class="username"
                      id="usernameInput"
                      value=""
                      placeholder="Username"
                    />
                  </div>
                  <div class="v1-input-field">
                    <input
                      type="text"
                      class="useremail"
                      id="emailInput"
                      value=""
                      placeholder="Email"
                    />
                  </div>
                  <div class="v1-input-field">
                    <input
                      type="password"
                      class="userpassword"
                      id="passwordInput"
                      value=""
                      placeholder="Password"
                    />
                  </div>
                  <div class="v1-input-field">
                    <input
                      type="text"
                      class="usersecretkey"
                      id="secretKeyInput"
                      value=""
                      placeholder="Customer Secret key"
                    />
                  </div>
                  <div class="input-google-captcha">
                    <img
                      src="@/assets/lems-v1/images/google-captcha-img.svg"
                      alt=""
                    />
                  </div>

                  <div class="input-submit buttons-rows sign-up-buttons-rows">
                    <button
                      class="left-btn v1-button-outline-black"
                      id="cancelButton"
                    >
                      {{ constants.CANCEL_BUTTON }}
                    </button>
                    <button
                      type="button"
                      id="signUpButton"
                      onclick="window.location.href = 'successfully-registered.html';"
                      class="v1-button-outline"
                    >
                      {{ constants.SIGN_UP_BUTTON }}
                    </button>
                    <div class="clear"></div>
                  </div>
                </form>
              </div>
            </div> -->
            <!---------------------------Sign Up Form End------------------->

            <!---------------------------Sign In Form Start------------------->
            <div class="form-container sign-in-container login">
              <div class="form-box">
                <h2>
                  {{ constants.LOGIN_TEXT }}
                </h2>
                <div
                  v-if="error"
                  class="error-message"
                  style="color: red; margin-bottom: 15px; text-align: center"
                >
                  {{ error }}
                </div>
                <form @submit.prevent="jiraLogin">
                  <div class="v1-input-field">
                    <input
                      type="text"
                      class="username"
                      id="usernameInput"
                      v-model="jiraForm.username"
                      placeholder="Username"
                    />
                    <span
                      v-if="errors.username && !jiraForm.username"
                      class="error-msg"
                      >{{ errors.username }}</span
                    >
                  </div>
                  <div class="v1-input-field">
                    <input
                      :type="showPassword ? 'text' : 'password'"
                      class="userpassword"
                      id="passwordInput"
                      v-model="jiraForm.password"
                      placeholder="Password"
                    />
                    <button
                      type="button"
                      class="password-toggle"
                      @click="togglePassword"
                    >
                      <i
                        :class="
                          showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'
                        "
                      ></i>
                    </button>
                    <span
                      v-if="errors.password && !jiraForm.password"
                      class="error-msg"
                      >{{ errors.password }}</span
                    >
                  </div>
                  <div class="v1-input-field">
                    <div class="custom-row">
                      <div class="remmember-input">
                        <input
                          type="checkbox"
                          name="cbG11"
                          id="rememberMeCheckbox"
                          class="css-checkbox"
                        />
                        <label for="rememberMeCheckbox" class="css-label">
                          {{ constants.REMEMBER_ME_LABEL }}
                        </label>
                      </div>
                      <a class="forgot-text" href="forgot-password.html">
                        {{ constants.FORGOT_PASSWORD_LINK }}
                      </a>
                    </div>
                  </div>

                  <div class="input-submit signup-submit">
                    <button
                      class="v1-button-outline"
                      type="submit"
                      id="loginButton"
                      :disabled="isLoading"
                    >
                      {{ isLoading ? "Logging in..." : constants.LOGIN_BUTTON }}
                    </button>
                    <div class="clear"></div>
                  </div>
                </form>
              </div>
            </div>
            <!---------------------------Sign In Form End------------------->
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import LoginHeader from "@/components/lems-v1/loginHeader.vue";
import Footer from "@/components/lems-v1/footer.vue";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";
import Swal from "sweetalert2";

export default defineComponent({
  name: "EmployeeLogin",
  components: {
    LoginHeader,
    Footer,
  },
  data() {
    return {
      constants,
      jiraForm: {
        username: "",
        password: "",
      },
      isLoading: false,
      error: "",
      showPassword: false,
      errors: {
        username: "",
        password: "",
      } as { [key: string]: string },
    };
  },
  mounted() {
    const isLoggedIn = localStorage.getItem("is_jira_loggedIn") === "true";
    if (isLoggedIn) {
      this.$router.push("/employee/dashboard");
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    validateField(fieldName: string) {
      this.errors[fieldName] = "";

      if (fieldName === "username") {
        if (!this.jiraForm.username.trim()) {
          this.errors.username = "Username is required";
        }
      } else if (fieldName === "password") {
        if (!this.jiraForm.password.trim()) {
          this.errors.password = "Password is required";
        }
      }
    },

    validateForm() {
      this.validateField("username");
      this.validateField("password");

      return !this.errors.username && !this.errors.password;
    },

    async jiraLogin() {
      // Clear previous errors
      this.error = "";
      this.errors.username = "";
      this.errors.password = "";

      // Validate form
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;

      try {
        const response = await axios.post(`${API_BASE_URL}/jira/login/`, {
          username: this.jiraForm.username,
          password: this.jiraForm.password,
          role: "EMPLOYEE",
        });
        localStorage.setItem("is_jira_loggedIn", "true");
        localStorage.setItem("jira_user_username", response.data.user.userName);
        Swal.fire({
          icon: "success",
          title: response.data.message,
        });
        this.$router.push("/employee/dashboard");
      } catch (error: any) {
        console.error("Login error:", error);
        Swal.fire({
          icon: "error",
          title: "Login failed",
          text: error.response?.data?.error || "An error occurred during login",
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
});
</script>

<style scoped>
.password-field {
  position: relative;
}

.password-toggle {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  font-size: 16px;
  padding: 5px;
}

.password-toggle:hover {
  color: #333;
}

.password-field input {
  padding-right: 40px;
}

.error-field {
  border-color: #dc3545 !important;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
}

.error-text {
  color: #dc3545;
  font-size: 12px;
  margin-top: 5px;
  display: block;
}

.v1-input-field {
  margin-bottom: 15px;
}
</style>
